import { RoomType, RoomData, Wing } from './types';

/**
 * NOREWYN AKADEMIETS ALDERSGRUPPER
 * Bruges til adgangskontrol (RoomAccessRules) og skema-filtrering.
 */
export const AGE_GROUPS = [
  "Hatchlings (Grade 0)",
  "Sparks (Grade 1)",
  "Embers (Grade 2)",
  "Fledglings (Grade 3)",
  "Drakes (Grade 4)",
  "Seekers (Grade 5)",
  "Sentinels (Grade 6)",
  "Wyverns (Grade 7)",
  "Stormriders (Grade 8)",
  "Flamebearers (Grade 9)",
  "Ascended (Grade 10)",
  "Vanguards (High School 1)",
  "Mystics (High School 2)",
  "Elders (High School 3)",
  "Parents/Observers"
] as const;

// Dette er kun standard-data til første gang appen kører på en tom database
export const BOOTSTRAP_WINGS: Wing[] = [
  { 
    id: 'wing-1', 
    name: 'Elementar-fløjen', 
    themeUrl: 'https://images.unsplash.com/photo-1464802686167-b939a67e06a1?q=80&w=2000', 
    roomIds: [RoomType.POTIONS, RoomType.HERBOLOGY] 
  },
  { 
    id: 'wing-2', 
    name: 'Videns-arkivet', 
    themeUrl: 'https://images.unsplash.com/photo-1507842217343-583bb7270b66?q=80&w=2000', 
    roomIds: [RoomType.ANCIENT_RUNES, RoomType.GREAT_HALL] 
  }
];

export const BOOTSTRAP_ROOMS: Record<string, RoomData> = {
  [RoomType.HALLWAY]: {
    id: RoomType.HALLWAY,
    name: "Akademiets Hall",
    description: "Hjertet af Norewyn.",
    zoomMeetingId: "",
  },
  [RoomType.POTIONS]: {
    id: RoomType.POTIONS,
    name: "Eliksirlaboratoriet",
    description: "Laboratorium for bryg og eliksirer.",
    zoomMeetingId: "https://skolenonline-dk.zoom.us/s/61464322416",
    wingIds: ['wing-1'],
    side: 'left',
    slot: 1
  },
  [RoomType.HERBOLOGY]: {
    id: RoomType.HERBOLOGY,
    name: "Drivhuset",
    description: "Studiet af magiske planter.",
    zoomMeetingId: "614 6432 2416",
    wingIds: ['wing-1'],
    side: 'right',
    slot: 2
  },
  [RoomType.ANCIENT_RUNES]: {
    id: RoomType.ANCIENT_RUNES,
    name: "Runekammeret",
    description: "Gamle hemmeligheder skrevet i sten.",
    zoomMeetingId: "844 5555 6666",
    wingIds: ['wing-2'],
    side: 'left',
    slot: 1
  },
  [RoomType.GREAT_HALL]: {
    id: RoomType.GREAT_HALL,
    name: "Storsalen",
    description: "Samlingspunkt for alle eventyrere.",
    zoomMeetingId: "899 0000 1111",
    wingIds: ['wing-2'],
    side: 'right',
    slot: 2
  },
};

export const AVATARS = [
  "https://picsum.photos/seed/wizard1/100/100",
  "https://picsum.photos/seed/witch1/100/100",
  "https://picsum.photos/seed/ranger1/100/100",
  "https://picsum.photos/seed/druid1/100/100",
];